import { render, staticRenderFns } from "./DeclarationDetailsSection.vue?vue&type=template&id=7d980a80&scoped=true&"
import script from "./DeclarationDetailsSection.vue?vue&type=script&lang=js&"
export * from "./DeclarationDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationDetailsSection.vue?vue&type=style&index=0&id=7d980a80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d980a80",
  null
  
)

export default component.exports